import type { Theme } from '@mui/material/styles';
import { palette } from '@openx/components-core/lib/theme/paletteV2.ts';

// the secondary yellow color is added to the old MUI palette, but the new design system doesn't implement that particular color yet
// once it is added there, the fallback can be removed
export const getOpenXAgentGradient = (theme: Theme) =>
  `linear-gradient(310.6deg, ${theme.palette.primary.main} 6.51%, ${theme.palette.background.yellowLight ?? palette.background.yellowLight} 87.85%)`;
